"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[915],{

/***/ 50135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(req, res) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, res), {
        currentPage: req.page || 1,
        pageSize: req.page_size,
        totalPages: Math.ceil(res.count / req.page_size)
    });
}


/***/ }),

/***/ 7061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pz": function() { return /* binding */ CustomerStatuses; },
/* harmony export */   "Up": function() { return /* binding */ convertSubscriptionToAPI; },
/* harmony export */   "Wm": function() { return /* binding */ convertShippingToAddress; },
/* harmony export */   "_$": function() { return /* binding */ BusinessType; },
/* harmony export */   "fS": function() { return /* binding */ getBillingPeriodDescription; },
/* harmony export */   "ji": function() { return /* binding */ convertAPISubscriptionToNormal; },
/* harmony export */   "ko": function() { return /* binding */ businessTypeDescriptions; },
/* harmony export */   "qL": function() { return /* binding */ convertAddressToShipping; },
/* harmony export */   "tv": function() { return /* binding */ BillingPeriod; }
/* harmony export */ });
/* unused harmony exports strings, APIBusinessType */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92903);
/* harmony import */ var common_project__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36877);



var CustomerStatuses = [
    "CANCELLED",
    "ACTIVE",
    "PENDING_CANCELLATION"
];
var BillingPeriod;
(function(BillingPeriod) {
    BillingPeriod[BillingPeriod["MONTHLY"] = 1] = "MONTHLY";
    BillingPeriod[BillingPeriod["ANNUAL"] = 2] = "ANNUAL";
})(BillingPeriod || (BillingPeriod = {}));
var getBillingPeriodDescription = function(v) {
    if (!v) {
        return null;
    }
    if (v === 1) {
        return "Monthly";
    } else {
        return "Annual";
    }
};
var convertAddressToShipping = function(address) {
    return {
        shipping_address_city: (address === null || address === void 0 ? void 0 : address.city) || "",
        shipping_address_country: (address === null || address === void 0 ? void 0 : address.country) || "",
        shipping_address_line_1: (address === null || address === void 0 ? void 0 : address.address_line_1) || "",
        shipping_address_line_2: (address === null || address === void 0 ? void 0 : address.address_line_2) || "",
        shipping_address_line_3: (address === null || address === void 0 ? void 0 : address.address_line_3) || "",
        shipping_address_postcode: (address === null || address === void 0 ? void 0 : address.postal_code) || ""
    };
};
var convertShippingToAddress = function(address) {
    return {
        address_line_1: (address === null || address === void 0 ? void 0 : address.shipping_address_line_1) || "",
        address_line_2: (address === null || address === void 0 ? void 0 : address.shipping_address_line_2) || "",
        address_line_3: (address === null || address === void 0 ? void 0 : address.shipping_address_line_3) || "",
        city: (address === null || address === void 0 ? void 0 : address.shipping_address_city) || "",
        country: (address === null || address === void 0 ? void 0 : address.shipping_address_country) || "",
        postal_code: (address === null || address === void 0 ? void 0 : address.shipping_address_postcode) || ""
    };
};
var BusinessType;
(function(BusinessType) {
    BusinessType["LIMITED_COMPANY"] = "LIMITED_COMPANY";
    BusinessType["SOLE_TRADER"] = "SOLE_TRADER";
    BusinessType["CHARITY"] = "CHARITY";
    BusinessType["UNINCORPORATED"] = "UNINCORPORATED";
    BusinessType["TRUST"] = "TRUST";
    BusinessType["ASSOCIATION"] = "ASSOCIATION";
})(BusinessType || (BusinessType = {}));


var strings = new react_localization__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z({
    en: {
        COMPANY_NUMBER: "Company Number",
        LIMITED_COMPANY: "Limited company (LTD, LP, LLP, LLC, Corp)"
    },
    "en-au": {
        COMPANY_NUMBER: "ABN/ACN",
        LIMITED_COMPANY: "Limited company (Pty Ltd, Ltd, LP)"
    }
});
if (common_project__WEBPACK_IMPORTED_MODULE_2__/* .Project.language */ .I.language) {
    strings.setLanguage("en-au");
}
var businessTypeDescriptions = {
    ASSOCIATION: "Association, club or society",
    CHARITY: "Charity / non-profit",
    LIMITED_COMPANY: strings.LIMITED_COMPANY,
    SOLE_TRADER: "Individual / sole trader",
    TRUST: "Trust, foundation or fund",
    UNINCORPORATED: "Unincorporated / not yet registered"
};
var APIBusinessType;
(function(APIBusinessType) {
    APIBusinessType[APIBusinessType["LIMITED_COMPANY"] = 1] = "LIMITED_COMPANY";
    APIBusinessType[APIBusinessType["SOLE_TRADER"] = 3] = "SOLE_TRADER";
    APIBusinessType[APIBusinessType["CHARITY"] = 10] = "CHARITY";
    APIBusinessType[APIBusinessType["UNINCORPORATED"] = 9] = "UNINCORPORATED";
    APIBusinessType[APIBusinessType["TRUST"] = 12] = "TRUST";
    APIBusinessType[APIBusinessType["ASSOCIATION"] = 13] = "ASSOCIATION";
})(APIBusinessType || (APIBusinessType = {}));
function getEnumKeyByValue(enumObject, value) {
    return Object.keys(enumObject).find(function(key) {
        return enumObject[key] === value;
    });
}
function convertSubscriptionToAPI(value) {
    return {
        "company": {
            "abn_number": value.abn_number,
            "acn_number": value.acn_number,
            "limited_company_number": value.company_number,
            "name": value.company_name,
            "organisation_type": APIBusinessType[value.business_type],
            "telephone_number": value.telephone_number,
            "trading_name": value.trading_name
        },
        "customer": {
            "email_address": value.email_address,
            "first_name": value.contact_first_name,
            "last_name": value.contact_last_name
        },
        external_id: value.external_id || undefined,
        "members": value.members,
        "product_id": value.plan_id,
        "shipping_address": {
            "shipping_address_city": value.address.city,
            "shipping_address_country": value.address.country,
            "shipping_address_line_1": value.address.address_line_1,
            "shipping_address_line_2": value.address.address_line_2,
            "shipping_address_line_3": value.address.address_line_3,
            "shipping_address_postcode": value.address.postal_code
        },
        status: "ACTIVE",
        "subscription": {
            "start_date": value.created_at || dayjs__WEBPACK_IMPORTED_MODULE_0___default()().format("YYYY-MM-DD")
        },
        subscription_id: value.id
    };
}
function convertAPISubscriptionToNormal(value) {
    var res = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, value), {
        abn_number: value.company.abn_number,
        acn_number: value.company.acn_number,
        address: {
            address_line_1: value.shipping_address.shipping_address_line_1,
            address_line_2: value.shipping_address.shipping_address_line_2,
            address_line_3: value.shipping_address.shipping_address_line_3,
            city: value.shipping_address.shipping_address_city,
            country: value.shipping_address.shipping_address_country,
            postal_code: value.shipping_address.shipping_address_postcode
        },
        business_type: getEnumKeyByValue(APIBusinessType, value.company.organisation_type),
        company_name: value.company.name,
        company_number: value.company.limited_company_number,
        contact_first_name: value.customer.first_name,
        contact_last_name: value.customer.last_name,
        created_at: value.subscription.start_date,
        email_address: value.customer.email_address,
        external_id: value.external_id,
        id: value.subscription_id,
        members: (value.members || []).map(function(v) {
            var ref, ref1, ref2;
            var kyc_id = (ref = v.documents) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                return v.type === "ID";
            });
            var kyc_poa = (ref1 = v.documents) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
                return v.type === "PROOF_OF_ADDRESS";
            });
            var audit_report = (ref2 = v.documents) === null || ref2 === void 0 ? void 0 : ref2.find(function(v) {
                return v.type === "AUDIT_REPORT";
            });
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, v), {
                audit_report: audit_report,
                kyc_id: kyc_id,
                kyc_poa: kyc_poa
            });
        }),
        plan_id: value.product_id,
        status: value.status,
        subscription: {
            end_date: value.subscription.end_date,
            start_date: value.subscription.start_date
        },
        telephone_number: value.company.telephone_number,
        trading_name: value.company.trading_name
    });
    return res;
}


/***/ }),

/***/ 57384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ fromParam; },
  "i": function() { return /* binding */ toParam; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./common/utils/array/omit.ts

var omit = function(obj, keys) {
    var output = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (!keys.includes(key)) {
                output.push([
                    key,
                    value
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Object.fromEntries(output);
};

;// CONCATENATED MODULE: ./common/utils/urls/param.ts


function fromParam(url) {
    // {min:100,max:200} <- ?min=100&max=200
    var documentSearch = typeof document === "undefined" ? "" : document.location.search;
    var str;
    if (url) {
        var split = url.split("/");
        str = split[split.length - 1];
    }
    if (!str && !documentSearch) {
        return {};
    }
    // eslint-disable-next-line
    var urlString = (str || documentSearch).replace(/(^\?)/, "");
    try {
        var params = new URLSearchParams(urlString);
        var entries = params.entries() //returns an iterator of decoded [key,value] tuples
        ;
        var result = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                // each 'entry' is a [key, value] tupple
                result[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    } catch (e) {
        return {};
    }
}
function toParam(obj) {
    // {min:100,max:200} -> ?min=100&max=200
    if (!obj) return "";
    var allDefined = omit(obj, Object.keys(obj).filter(function(key) {
        return typeof obj[key] === "undefined" || obj[key] === null;
    }));
    return Object.keys(allDefined).map(function(k) {
        // @ts-ignore
        var val = allDefined[k];
        if (Array.isArray("array")) {
            val = val.join(",");
        }
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(val));
    }).join("&");
}


/***/ }),

/***/ 41280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports themeClassNames, sizeClassNames */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11720);
/* harmony import */ var react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46977);








var themeClassNames = {
    danger: "btn btn-danger",
    outlinePrimary: "btn btn-outline-primary",
    outlineDanger: "btn btn-outline-danger",
    primary: "btn-primary",
    secondary: "btn-secondary",
    tertiary: "btn-tertiary",
    text: "btn-link fw-semibold"
};
var sizeClassNames = {
    default: "",
    "extra-small": "btn-xs",
    large: "btn-lg",
    small: "btn-sm"
};
var Button = function(_param) {
    var children = _param.children, className = _param.className, hideShortcut = _param.hideShortcut, icon = _param.icon, iconLeft = _param.iconLeft, iconRight = _param.iconRight, onClick = _param.onClick, shortcut = _param.shortcut, shortcutLeft = _param.shortcutLeft, _size = _param.size, size = _size === void 0 ? "default" : _size, _theme = _param.theme, theme = _theme === void 0 ? "primary" : _theme, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "hideShortcut",
        "icon",
        "iconLeft",
        "iconRight",
        "onClick",
        "shortcut",
        "shortcutLeft",
        "size",
        "theme"
    ]);
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleClick = function(e) {
        if (!rest.disabled) {
            var ref;
            (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.blur();
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    };
    (0,react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_3__/* .useHotkeys */ .y1)(shortcut || "", handleClick, [
        onClick
    ]);
    var shortcutEl = shortcut && !hideShortcut && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("i", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("key__button", {
            "me-2": !!shortcutLeft
        }),
        children: shortcut === "Enter" ? "⏎" : shortcut === "ArrowLeft" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
            className: "fa fa-arrow-left"
        }) : shortcut === "ArrowRight" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
            className: "fa fa-arrow-right"
        }) : shortcut
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        type: "button",
        ref: buttonRef
    }, rest), {
        onClick: handleClick,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn", {
            "btn-icon": !!icon,
            "flex-row lh-1 align-items-center": !!shortcut
        }, className, themeClassNames[theme], sizeClassNames[size]),
        children: [
            iconLeft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("i", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("icon icon--left", "me-2", iconLeft)
            }),
            !!shortcutLeft && shortcutEl,
            children,
            iconRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("i", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("icon icon--right", "ms-2", iconRight)
            }),
            !shortcutLeft && shortcutEl
        ]
    }));
};
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 4386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ forms_Input; }
});

// UNUSED EXPORTS: sizeClassNames

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./common/utils/forms/keys.ts
var KEY_Y = 89;
var KEY_Z = 90;
var keys = {
    isBackspace: function isBackspace(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 8 && !e.shiftKey && !e.ctrlKey;
    },
    isDown: function isDown(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 40 && !e.shiftKey && !e.ctrlKey;
    },
    isEnter: function isEnter(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 13 && !e.shiftKey && !e.ctrlKey;
    },
    isEscape: function isEscape(e) {
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 27 && !e.shiftKey && !e.ctrlKey;
    },
    isLeft: function isLeft(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 37 && !e.shiftKey && !e.ctrlKey;
    },
    isRedo: function isRedo(e) {
        if (!e) return false;
        return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEY_Z : KEY_Y);
    },
    isRight: function isRight(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 39 && !e.shiftKey && !e.ctrlKey;
    },
    isTab: function isTab(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 9 && !e.shiftKey && !e.ctrlKey;
    },
    isUndo: function isUndo(e) {
        if (!e) return false;
        return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEY_Y : KEY_Z);
    },
    isUp: function isUp(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 38 && !e.shiftKey && !e.ctrlKey;
    }
};

;// CONCATENATED MODULE: ./components/base/forms/Input.tsx







var sizeClassNames = {
    default: "",
    large: "form-control-lg",
    small: "form-control-sm"
};
var Input = function(_param) {
    var children = _param.children, className = _param.className, disabled = _param.disabled, iconLeft = _param.iconLeft, iconRight = _param.iconRight, id = _param.id, inputClassName = _param.inputClassName, inputRef = _param.inputRef, _isValid = _param.isValid, isValid = _isValid === void 0 ? true : _isValid, name = _param.name, onBlur = _param.onBlur, onFocus = _param.onFocus, onIconLeftClick = _param.onIconLeftClick, onIconRightClick = _param.onIconRightClick, onKeyDown = _param.onKeyDown, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? " " : _placeholder, _shouldValidate = _param.shouldValidate, _size = _param.size, size = _size === void 0 ? "default" : _size, textarea = _param.textarea, touched = _param.touched, type = _param.type, value = _param.value, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "disabled",
        "iconLeft",
        "iconRight",
        "id",
        "inputClassName",
        "inputRef",
        "isValid",
        "name",
        "onBlur",
        "onFocus",
        "onIconLeftClick",
        "onIconRightClick",
        "onKeyDown",
        "placeholder",
        "shouldValidate",
        "size",
        "textarea",
        "touched",
        "type",
        "value"
    ]);
    var ref = (0,compat_module.useState)(false), shouldValidate = ref[0], setShouldValidate = ref[1];
    (0,compat_module.useEffect)(function() {
        if (_shouldValidate) {
            setShouldValidate(true);
        }
    }, [
        _shouldValidate
    ]);
    var ref1 = (0,compat_module.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var ref2 = inputRef || (0,compat_module.useRef)();
    var focusHandler = function(e) {
        setIsFocused(true);
        onFocus && onFocus(e);
    };
    var onKeyDownHandler = function(e) {
        if (keys.isEscape(e)) {
            var ref;
            (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.blur();
        }
        onKeyDown && onKeyDown(e);
    };
    var blurHandler = function(e) {
        setShouldValidate(true);
        setIsFocused(false);
        onBlur && onBlur(e);
    };
    var togglePasswordVisibility = function() {
        setShowPassword(!showPassword);
    };
    var classNameHandler = classnames_default()("position-relative input-container", {
        focused: isFocused,
        "input-container--with-left-icon": !!iconLeft,
        "input-container--with-right-icon": !!iconRight,
        invalid: (shouldValidate || touched) && !isValid
    }, className);
    var combinedInputClassName = classnames_default()({
        error: !(shouldValidate || touched) && !isValid,
        "form-control": true
    }, // @ts-ignore
    sizeClassNames[size], inputClassName);
    var ref3 = (0,compat_module.useState)(false), showPassword = ref3[0], setShowPassword = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: classNameHandler,
        children: [
            textarea ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                name: name,
                placeholder: placeholder
            }, rest), {
                id: id,
                // @ts-ignore
                ref: ref2,
                onFocus: focusHandler,
                onKeyDown: onKeyDownHandler,
                onBlur: blurHandler,
                value: value,
                className: combinedInputClassName
            })) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    !!iconLeft && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        onClick: onIconLeftClick,
                        className: classnames_default()("input-icon icon-left", {
                            "icon-disabled": disabled,
                            "pe-none": !onIconLeftClick
                        }),
                        children: iconLeft
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        disabled: disabled,
                        name: name,
                        type: type === "password" && showPassword ? "" : type
                    }, rest), {
                        id: id,
                        // @ts-ignore
                        ref: ref2,
                        onFocus: focusHandler,
                        onKeyDown: onKeyDownHandler,
                        onBlur: blurHandler,
                        value: value,
                        placeholder: placeholder,
                        className: combinedInputClassName
                    })),
                    iconRight ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        onClick: onIconRightClick,
                        className: classnames_default()("input-icon icon-right", {
                            "icon-disabled": disabled,
                            "pe-none": !onIconRightClick
                        }),
                        children: iconRight
                    }) : type === "password" && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("i", {
                        onClick: togglePasswordVisibility,
                        className: classnames_default()("input-icon icon-right", {
                            "fas fa-eye": !showPassword,
                            "fas fa-eye-slash": showPassword,
                            "icon-disabled": disabled
                        })
                    })
                ]
            }),
            children && children
        ]
    });
};
Input.displayName = "Input";
/* harmony default export */ var forms_Input = (Input);


/***/ }),

/***/ 58086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var ContentContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("px-5 py-4 bg-white shadow-2 rounded-lg", className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ })

}]);